// Las ~74 concatenaciones existentes asumen slash final (`urls + 'productos'`).
const withTrailingSlash = (v: string) => (v.endsWith('/') ? v : v + '/');

const rawApi = (process.env.REACT_APP_BACKURL || '').trim();
const rawImages = (process.env.REACT_APP_BACKIMAGES || '').trim();

// Vacío => mismo origen que sirve la SPA (modo contenedor unificado).
export const API_URL = rawApi ? withTrailingSlash(rawApi) : '/api/';
export const IMAGES_URL = rawImages ? withTrailingSlash(rawImages) : '/images/';
